import React, { useRef, useState } from "react";
import IconInformeAuditoria from "../../assets/img/iconInformeAuditoria";
import IconPlanAuditoria from "../../assets/img/iconPlanAuditoria";
import { IComboboxOption } from "../../entities/helper/IComboboxOption";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import { ITipoAuditoria } from "../../entities/ITipoAuditoria";
import { getAPI } from "../../helpers/httpHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserToken, cognitoUserInfo } from "../../helpers/userHelper";
import {
  API_ADMIN_GERENCIA,
  API_ADMIN_TIPO_AUDITORIA,
  API_ADMIN_UNIDAD,
  API_AUDITORIA,
  API_AUDITORIA_GET_AUDITORIA,
  API_AUDITORIA_GET_REPORTESABANAAUDITORIA,
  ROW_COUNT,
  URL_SUPPORT,
} from "../../helpers/variableHelper";
import Select from "react-select";
import IUnidad from "../../entities/IUnidad";
import IVicePresidencia from "../../entities/IVicePresidencia";
import IGerencia from "../../entities/IGerencia";
import { createColumnHelper, CellContext } from "@tanstack/react-table";
import { shortDate } from "../../helpers/dateHelper";
import { ITipo_Campo } from "../../helpers/IFormHelper";
import IReporteSabana from "../../entities/IReporteSabana";
import AuditoriaService from "../../services/AuditoriaService";
import { EnumEstadoAuditoria } from "../../entities/helper/EnumEstadoAuditoria";
import DetalleAuditoria from "./components/DetalleAuditoria";
import IAuditoria from "../../entities/IAuditoria";
import { AdminListaPagination, IPagination } from "../../controls/AdminListaPagination";
import VppService from "../../services/VppService";
import Loading from "../../cross/Loading";
import moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import RenderTitle from "../../controls/RenderTitle";
import RenderValue from "../../controls/RenderValue";
import { cParamsActiveOrderNombre, cParamsActiveOrderTitle } from "../../helpers/paramsHelper";
const MySwal = withReactContent(Swal);

interface ReporteSabanaTest {
  items?: Array<any>;
  mostrarTabla?: boolean;
  loading?: boolean;
  cbTA?: Array<ITipoAuditoria>;
  cbAllViceprecidencia?: Array<IVicePresidencia>;
  cbAllGerencia?: Array<IGerencia>;
  cbAllUnidad?: Array<IUnidad>;
}

export default function ReporteriaSabana({
  items,
  mostrarTabla,
  loading = true,
  cbTA,
  cbAllViceprecidencia,
  cbAllGerencia,
  cbAllUnidad,
}: ReporteSabanaTest) {
  const userInfo = cognitoUserToken();
  const totalPageList = useRef<number>(0);
  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [showDetails, setShowDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(loading);

  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [listItems, setListItems] = useState<Array<any>>(items || []);
  const [comboTA, setComboTA] = useState<Array<ITipoAuditoria>>(cbTA || []);
  const refTxtNroAdutoria = React.createRef<HTMLInputElement>();
  const refTxtFechaDesde = React.createRef<HTMLInputElement>();
  const refTxtFechaHasta = React.createRef<HTMLInputElement>();
  const [refComboTA, setValComboTA] = useState<IComboboxOption | null>(null);
  const [filtersState, setFiltersState] = useState<any>({});
  const [allVicepresidencia, setAllVicepresidencia] = useState<Array<IVicePresidencia>>(cbAllViceprecidencia || []);
  const [allGerencia, setAllGerencia] = useState<Array<IGerencia>>(cbAllGerencia || []);
  const [allUnidad, setAllUnidad] = useState<Array<IUnidad>>(cbAllUnidad || []);
  const [valVicepresidencia, setValVicepresidencia] = useState<IComboboxOption | null>(null);
  const [valGerencia, setValGerencia] = useState<IComboboxOption | null>(null);
  const [valUnidad, setValUnidad] = useState<IComboboxOption | null>(null);
  const [showTable, setShowTable] = useState(mostrarTabla || false);
  const [auditoriaSeleccionada, setAuditoriaSeleccionada] = useState<IAuditoria | null>(null);
  console.log(currentUser);
  console.log(pages);
  console.log(page);
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentVer = (value: any) => {
    return (
      <div>
        <i
          className="bi bi-search"
          title="Ver Auditoría"
          onClick={async () => {
            setShowDetails(true);
            let resultGetAuditoria: IAuditoria = (
              await getAPI(`${API_AUDITORIA}${API_AUDITORIA_GET_AUDITORIA}`, { Authorization: `Bearer ${token}` }, { ID: value.row.original.ID })
            ).result;
            setAuditoriaSeleccionada(resultGetAuditoria);
          }}></i>
        {value.row.original.ID_ESTADO_AUDITORIA > EnumEstadoAuditoria.PlanListo && (
          <a href={`plan?id=${value.row.original.ID}`} className="text-decoration-none me-1">
            <IconPlanAuditoria />
          </a>
        )}
        {value.row.original.ID_ESTADO_AUDITORIA > EnumEstadoAuditoria.InformeListo && (
          <a href={`planInforme?id=${value.row.original.ID}`} className="text-decoration-none me-1">
            <IconInformeAuditoria />
          </a>
        )}
      </div>
    );
  };

  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    const combo = (
      await getAPI(
        `${URL_SUPPORT}${API_ADMIN_TIPO_AUDITORIA}/getall`,
        { Authorization: `Bearer ${token}` },
        { ...cParamsActiveOrderNombre, ORDENADOPOR: "NOMBRE", ORIENTACION: "ASC" }
      )
    ).result.data;
    setComboTA(combo);

    let resultAllVicepresidencia = (await VppService.getAll(token, cParamsActiveOrderTitle)).result;
    setAllVicepresidencia(resultAllVicepresidencia.data);
  }, []);

  const columnHelperMantIncCausa = createColumnHelper<IReporteSabana>();
  let columnsDef = [
    columnHelperMantIncCausa.accessor((row) => row.CORRELATIVO, {
      id: "CORRELATIVO_COLUMNA",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(info.getValue()),
      header: () => component("Correlativo"),
      tipo: ITipo_Campo.text,
      sortId: `AU."CORRELATIVO"`,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.ASUNTO, {
      id: "ASUNTO",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(info.getValue()),
      header: () => component("Asunto"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.ID, {
      id: "VER",
      cell: (
        info: CellContext<IReporteSabana, string> //
      ) => componentVer(info),
      header: () => component("Ver"),
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA_COLUMNA",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(info.getValue()),
      header: () => component("Vicepresidencia"),
      tipo: ITipo_Campo.text,
      sortId: `VICEPRESIDENCIA`,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.GERENCIA_SUBGERENCIA, {
      id: "GERENCIA_SUBGERENCIA_COLUMNA",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(info.getValue()),
      header: () => component("Gerencia/Subgerencia"),
      tipo: ITipo_Campo.text,
      sortId: `GERENCIA_SUBGERENCIA`,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.UNIDAD_PROYECTO, {
      id: "UNIDAD_PROYECTO_COLUMNA",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(info.getValue()),
      header: () => component("Unidad Proyecto"),
      tipo: ITipo_Campo.text,
      sortId: `UNIDAD_PROYECTO`,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.PROGRAMA_AUDITORIA, {
      id: "PROGRAMA_AUDITORIA",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(info.getValue()),
      header: () => component("Programa Auditoría"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.TIPO_AUDITORIA, {
      id: "TIPO_AUDITORIA_COLUMNA",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(info.getValue()),
      header: () => component("Tipo Auditoría"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.ESTADO_AUDITORIA, {
      id: "ESTADO_AUDITORIA",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(info.getValue()),
      header: () => component("Estado"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.AUDITOR_LIDER_DISPLAY, {
      id: "AUDITOR_LIDER",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(info.getValue()),
      header: () => component("Auditor Líder"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.FECHA_DESDE, {
      id: "FECHA_DESDE_COLUMNA",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Desde"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.FECHA_HASTA, {
      id: "FECHA_HASTA_COLUMNA",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Hasta"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.CORRELATIVO_ITEM_NORMATIVO, {
      id: "CORRELATIVO_ITEM_NORMATIVO",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(info.getValue()),
      header: () => component("Correlativo Ítem Normativo"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.FECHA_ITEM, {
      id: "FECHA_ITEM",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Fecha Ítem"),
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.TIPO_DESVIACION, {
      id: "TIPO_DESVIACION",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(info.getValue()),
      header: () => component("Tipo Desviación"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.AMBITO_DESVIACION, {
      id: "AMBITO_DESVIACION",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(info.getValue()),
      header: () => component("Ámbito Desviación"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.POTENCIALIDAD, {
      id: "POTENCIALIDAD",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(info.getValue()),
      header: () => component("Potencialidad"),
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.FECHA_CREACION, {
      id: "FECHA_CREACION",
      cell: (info: CellContext<IReporteSabana, string>) => componentValue(shortDate(info.getValue())),
      header: () => component("Creado el"),
      tipo: ITipo_Campo.date,
    } as any),
  ] as any;

  const handleValidacionBusqueda = () => {
    let arrErrors = [];
    if (
      !refTxtNroAdutoria.current?.value &&
      !valVicepresidencia?.value &&
      !valGerencia?.value &&
      !valUnidad?.value &&
      !refComboTA?.value &&
      !moment(refTxtFechaDesde.current?.value).isValid() &&
      !moment(refTxtFechaHasta.current?.value).isValid()
    ) {
      arrErrors.push("Debe ingresar un filtro");
    }
    if (moment(refTxtFechaDesde.current?.value) > moment(refTxtFechaHasta.current?.value)) {
      arrErrors.push("Fecha detección desde no puede ser superior a fecha hasta");
    }
    if (arrErrors.length > 0) {
      MySwal.fire({
        html: (
          <div>
            <h3>Favor seleccione lo siguiente:</h3>
            {arrErrors.map((e) => (
              <p key={e}>{e}</p>
            ))}
          </div>
        ),
        icon: "warning",
        confirmButtonText: "Aceptar",
        showCloseButton: true,
        showCancelButton: false,
      });

      return false;
    }
    return true;
  };

  const filter = async (filters: Partial<IReporteSabana>, page: boolean = false, size = pageSize) => {
    if (!filters) {
      filters = {};
    }
    filters.PAGINADO = filters?.PAGINADO || size;
    filters.PAGINA = filters?.PAGINA || 1;

    if (filters.ORDENADOPOR === undefined) {
      filters.ORDENADOPOR = "ID";
      filters.ORIENTACION = "DESC";
    }

    filters = {
      ...filters,
      TIPO_AUDITORIA: refComboTA?.label,
      CORRELATIVO: refTxtNroAdutoria.current?.value || "",
      VICEPRESIDENCIA: valVicepresidencia?.label,
      GERENCIA_SUBGERENCIA: valGerencia?.label,
      UNIDAD_PROYECTO: valUnidad?.label,
      FECHA_DESDE: refTxtFechaDesde.current?.value ? new Date(refTxtFechaDesde.current.value) : null,
      FECHA_HASTA: refTxtFechaHasta.current?.value ? new Date(refTxtFechaHasta.current.value) : null,
    };
    if (handleValidacionBusqueda()) {
      setShowTable(true);
      setIsLoading(true);
      setPage(filters.PAGINA as number);
      setFiltersState(filters);
      let result = await getAPI(`${API_AUDITORIA}${API_AUDITORIA_GET_REPORTESABANAAUDITORIA}`, { Authorization: `Bearer ${token}` }, filters);
      setListItems(result.result.data);
      let pages = result.result.pages;
      totalPageList.current = pages;
      setPages(pages);
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="row">
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-4">
              <h1 className="titPrincipal colorTit">Reporte Sábana Auditoría</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Nota:</strong> Este reporte permite consultar Auditoría realizadas en un período de tiempo.
                </small>
              </div>
              <div className="card bg-light border p-3 pt-2 mt-2">
                <div className="row ajusteInput">
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label>Tipo Auditoría</label>
                    <Select
                      options={
                        comboTA.map((vcc) => ({
                          value: vcc.NOMBRE,
                          label: vcc.NOMBRE,
                        })) as any
                      }
                      placeholder="Seleccione"
                      value={refComboTA || ""}
                      isClearable={true}
                      onChange={async (e: any) => {
                        setValComboTA(e);
                      }}
                    />
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label className="text-sm">Número de Auditoría (ejemplo 350;351):</label>
                    <input className="form-control form-control-sm" type="number" placeholder="Indique numero de auditoria" ref={refTxtNroAdutoria} />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label>Vicepresidencia :</label>
                    <Select
                      placeholder="Seleccione"
                      isClearable={true}
                      noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                      options={
                        allVicepresidencia.map((i) => ({
                          value: i.ID,
                          label: i.TITULO,
                        })) as any
                      }
                      value={valVicepresidencia || ""}
                      onChange={async (e: any) => {
                        setValVicepresidencia(e);
                        setValGerencia(null);
                        setAllGerencia([]);
                        setValUnidad(null);
                        setAllUnidad([]);
                        let resultAllGerencia = (
                          await getAPI(
                            `${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`,
                            { Authorization: `Bearer ${token}` },
                            { ...cParamsActiveOrderTitle, VICEPRESIDENCIA: e.label }
                          )
                        ).result;
                        setAllGerencia(resultAllGerencia.data);
                      }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label>Gerencia/Subgerencia:</label>
                    <Select
                      placeholder="Seleccione"
                      isClearable={true}
                      noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                      options={
                        allGerencia.map((i) => ({
                          value: i.ID,
                          label: i.TITULO,
                        })) as any
                      }
                      value={valGerencia || ""}
                      onChange={async (e: any) => {
                        setValGerencia(e);
                        setValUnidad(null);
                        setAllUnidad([]);

                        let resultAllUnidad: Array<IUnidad> = (
                          await getAPI(
                            `${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`,
                            { Authorization: `Bearer ${token}` },
                            {
                              ...cParamsActiveOrderTitle,
                              NOMBRE_GERENCIA_SUBGERENCIA: e.label,
                            }
                          )
                        ).result.data;
                        setAllUnidad(resultAllUnidad);
                      }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label>Unidad Proyecto:</label>
                    <Select
                      placeholder="Seleccione"
                      isClearable={true}
                      noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                      options={
                        allUnidad.map((i) => ({
                          value: i.ID,
                          label: i.TITULO,
                        })) as any
                      }
                      value={valUnidad || ""}
                      onChange={async (e: any) => {
                        setValUnidad(e);
                      }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0"></div>
                  <div className="col-sm-12 col-md-6 col-lg-6 pt-0">
                    <label className="text-sm">Fecha inicio plan de auditoría (desde - hasta)</label>
                    <div className="d-flex">
                      <input className="form-control form-control-sm w-50 me-2" type="date" placeholder="desde" ref={refTxtFechaDesde} />
                      <input className="form-control form-control-sm w-50" type="date" placeholder="hasta" ref={refTxtFechaHasta} />
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        filter({});
                      }}>
                      {" "}
                      <i className="bi bi-search me-2"></i> Buscar
                    </button>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => {
                        (refTxtNroAdutoria.current as HTMLInputElement).value = "";
                        (refTxtFechaDesde.current as HTMLInputElement).value = "";
                        (refTxtFechaHasta.current as HTMLInputElement).value = "";

                        setValComboTA(null);
                        setValVicepresidencia(null);
                        setValGerencia(null);
                        setValUnidad(null);
                        filter({});
                      }}>
                      {" "}
                      <i className="bi bi-trash me-2"></i>Limpiar
                    </button>
                  </div>
                </div>
              </div>

              <div className="" id="collapseGeneradas">
                <div className="card card-body border-0 p-0 mt-2">
                  <div className="row">
                    <div className="col-12">
                      <div className="container-fluid mb-4">
                        <h1 className="titPrincipal colorTit mt-2"></h1>
                        <div className="row">
                          <div className="col-12 table-responsive">
                            {showTable && (
                              <AdminListaPagination
                                defaultSortBy="ID"
                                sortDirection="ASC"
                                totalPages={totalPageList}
                                resultPerPage={ROW_COUNT}
                                hideAdd={true}
                                hideExport={false}
                                data={listItems}
                                callbackUpdatePageSize={(pageSize: number, filters: Object) => {
                                  setPageSize(pageSize);
                                  let pagination = filters as IPagination;
                                  pagination.PAGINADO = pageSize;
                                  filter(pagination);
                                }}
                                callback={async (pagination: any) => {
                                  pagination.ORIENTACION = "DESC";
                                  await filter(pagination);
                                }}
                                reload={filter}
                                exportar={async () => {
                                  setIsLoading(true);
                                  await AuditoriaService.ExportExcelReporteSabana(token, filtersState);
                                  setIsLoading(false);
                                }}
                                columnsDef={columnsDef}
                                isLoading={isLoading}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DetalleAuditoria
          auditoriaSeleccionada={auditoriaSeleccionada}
          show={showDetails}
          callbackClose={() => {
            setShowDetails(false);
            setAuditoriaSeleccionada(null);
          }}
          token={token}
        />
      </div>
    </div>
  );
}
